import styled from 'styled-components';
import { fontWeights } from 'ui/theme';
import { VerificationProfile } from '../../../../types';
import { Name, RightContent, Row } from '../../Email/EmailChannelRow.styled';

const IdDetail = styled.span`
  font-weight: ${fontWeights.semiBold};
`;

export type Props = {
  verificationProfile: VerificationProfile;
};

export const VerificationProfileRow = ({ verificationProfile }: Props) => {
  const { id, profileId } = verificationProfile;

  return (
    <Row>
      <Name>{profileId}</Name>
      <RightContent>
        Use this ID in your backend SMS Verification requests |<IdDetail>{`ID ${id}`}</IdDetail>
      </RightContent>
    </Row>
  );
};
